var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":_vm.$t('close')},on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])
}
var staticRenderFns = []

export { render, staticRenderFns }